import React, { useContext } from 'react'

//Node Modules
import {Dropdown, Nav} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

//Components
import { CheckmarkIcon, GlobeIcon } from 'components/SASIcon'

//Styles
import styles from './LanguageSelector.module.scss'

//Context
import { LanguageContext, AvailableLanguagesContext } from 'context/language-context'

//Util
import { LANGUAGE_ENGLISH } from 'util/constants'
import { find, languages, Language } from 'util/languages'

//Hooks
import { useIsSmallDevice } from 'hooks'

interface Props {
  isHelp?: boolean
}

const LanguageSelector = ({isHelp}: Props) => {

  const current = useContext(LanguageContext)
  const available = useContext(AvailableLanguagesContext)
  const isSmallDevice = useIsSmallDevice()
  const { t } = useTranslation()
  const language = find(current)
  const availableLanguages = languages
    .filter(l => available.indexOf(l.code) !== -1)
    .sort((a, b) => a.english > b.english ? 1 : -1)
  const languageText = (language:Language) => language.code === LANGUAGE_ENGLISH ? language.english : `${language.name} (${language.english})`
  const languageHref = (code: string) => {
    let url = window.location.href.replace(`/${current}/`, `/${code}/`).split("?")[0]
    return isHelp ? url +'?help' : url
  }

  const currentLanguageAvailable = language && availableLanguages.indexOf(language) !== -1
  const currentLanguageText = language ? languageText(language) : current
  const currentLanguageMessage = currentLanguageAvailable ? currentLanguageText : `${currentLanguageText} - ${t('helpcenter-gui-icu.language.unavailable.label')}`

  return (
    <Dropdown as={Nav.Item} drop="down" className={`${styles.dropdown} ${isSmallDevice ? styles.isSmallDevice  : ''} `} alignRight>
      <Dropdown.Toggle 
        id="language-toggle" 
        as={Nav.Link}
        data-testid="current-language"
        className={styles.toggle}
        title={currentLanguageMessage}
      >
        <GlobeIcon />
      </Dropdown.Toggle>
      <Dropdown.Menu 
        className={styles.menu}
        data-testid="language-menu"
        role="application"
      >
        { 
          availableLanguages.map(availLang => (
            <Dropdown.Item 
              key={availLang.code}
              active={availLang.code === current}
              href={languageHref(availLang.code)}
              target="_blank"
              data-testid="available-language"
              className={styles.item}
              rel="noopener"
            >
              { availLang.code === current && <span className={styles.active}><CheckmarkIcon /></span> }
              { languageText(availLang) }
            </Dropdown.Item>
          ))
        }
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LanguageSelector